import config from "@/config";
import mixpanel from "mixpanel-browser";
import { funFacts } from "./data";
import posthog from "posthog-js";
// import * as Sentry from "@sentry/react";
// import posthog from 'posthog-js'
// posthog.init('phc_8WFPlinTdV6RP5xUBY1mR9C2oIXpwL6miOSD45amYne', { api_host: 'https://us.i.posthog.com' })
export const supportURL = "https://wa.me/918920254690?text=Hello%20CirclePe"; //tel:8368376123 //

// Turns a backend journey-link value into a SAFE, absolute URL before we hand it
// to window.location.href.
//
// Why this exists (the /p/undefined/b/<id> 404 bug):
// The B2B backend builds journey links as `${BASE_FE_URL}/b/<link_id>`. When the
// backend's BASE_FE_URL env var is missing, that template collapses to the literal
// RELATIVE string "undefined/b/<link_id>" — no "https://", no host, no leading "/".
// If we assign that straight to window.location.href while the tenant is on, say,
// "/p/housr?step=sign-up", the browser resolves the relative value against the
// CURRENT directory ("/p/") and navigates to "/p/undefined/b/<link_id>", which
// matches no route and shows the router's 404 ("Unexpected Application Error").
//
// This mirrors the B2B dashboard's toPublicSessionUrl guard so the tenant redirect
// is just as bulletproof: strip a stray leading "undefined"/"null", rewrite the two
// known internal journey domains to the public one, and force the value absolute
// against THIS app's own origin. Returns "" for empty input so callers can no-op.
export const toAbsoluteJourneyUrl = (rawUrl = "") => {
  let url = String(rawUrl || "").trim();
  if (!url) return "";

  // Never send a tenant to an internal host: rewrite the two known-internal journey
  // domains to the public one. Anchored to the full "join.circlepe." prefix so an
  // already-public "join.circlepe.in" URL is left untouched.
  url = url.replace(/join\.circlepe\.(?:club|crib\.in)\b/gi, "join.circlepe.in");

  // Already absolute (has a scheme) — safe to use as-is.
  if (/^https?:\/\//i.test(url)) return url;
  // Protocol-relative ("//host/path") — pick https so it resolves cleanly.
  if (url.startsWith("//")) return `https:${url}`;

  // Relative path: drop the leading literal "undefined"/"null" left by the missing
  // env var (and any leading slashes), then anchor to this app's own origin — NOT
  // the current pathname — so we never inherit a "/p/<partner>" prefix.
  const path = url.replace(/^(?:undefined|null)\b/i, "").replace(/^\/+/, "");
  return `${window.location.origin}/${path}`;
};
export function formatINR(amount = "") {
  if (!amount) return null;

  // Ensure the input is treated as a string to handle numbers and strings properly
  const amountStr = amount.toString().trim();

  if (amountStr?.length < 5) return "₹" + amountStr;

  // Split the amount into integer and decimal parts
  const parts = amountStr.split(".");
  const integerPart = parts[0];
  const decimalPart = parts.length > 1 ? "." + parts[1].slice(0, 2) : "";

  // Handle the Indian numbering system
  const lastThreeDigits = integerPart.slice(-3); // Last 3 digits
  const remainingDigits = integerPart.slice(0, -3); // All digits except last 3

  // Format the remaining digits in groups of 2
  const formattedRemainingDigits = remainingDigits.replace(
    /\B(?=(\d{2})+(?!\d))/g,
    ","
  );

  // Combine the formatted parts
  const formattedIntegerPart =
    formattedRemainingDigits +
    (remainingDigits.length > 0 ? "," : "") +
    lastThreeDigits;

  return "₹" + formattedIntegerPart + decimalPart;
}

export function getRandomFact() {
  const randomIndex = Math.floor(Math.random() * funFacts.length);
  return funFacts[randomIndex];
}

export function isValidPhone(phone) {
  const phonePattern = /^\d{10}$/;

  return phonePattern.test(phone);
}

export const isValidateName = (name) => {
  const regex = /^[a-zA-Z\s]+$/;
  return typeof name === "string" && name.trim().length > 3 && regex.test(name);
};

export function isValidEmail(email) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailPattern.test(email);
}

export function isValidPinCode(pinCode) {
  const pinCodePattern = /^\d{6}$/;

  return pinCodePattern.test(pinCode);
}

export function isValidPANCard(panCard) {
  const panCardPattern = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

  return panCardPattern.test(panCard);
}

export async function isWorkEmail(email) {
  // Basic email format validation (not RFC-perfect, but works for most cases)
  // Explanation:
  //  ^[^\s@]+      : One or more non-whitespace, non-@ chars at the start
  //  @[^\s@]+      : An @ symbol followed by one or more non-whitespace, non-@ chars
  //  \.[^\s@]+$    : A '.' followed by one or more non-whitespace, non-@ chars until the end
  const emailRegex = /[A-Za-z0-9\._%+\-]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,}/;
  if (!emailRegex.test(email)) {
    return false; // Invalid email format
  }

  const journeyData = await fetchData("journey/full");

  if (journeyData?.allowAnyEmail || journeyData?.journey?.allowAnyEmail) {
    return true;
  }
  // Common free email domains (customize as needed)
  const freeEmailDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "live.com",
    "aol.com",
    "icloud.com",
    "protonmail.com",
  ];

  // Extract the domain from the email (the part after @)
  const domain = email.split("@")[1].toLowerCase();

  // Check if the domain is in our list of free/generic email providers
  if (freeEmailDomains.includes(domain)) {
    return false; // It's not considered a "work" email
  }

  return true; // Passed both tests, likely a work email
}

export const splitFullName = (fullName) => {
  const nameParts = fullName.trim().split(" ");

  const firstName = nameParts[0];
  const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";
  const middleName =
    nameParts.length > 2 ? nameParts.slice(1, -1).join(" ") : "";

  return {
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
  };
};

const clickedApis = [];

export const updateFunction = async (
  data,
  apiPath,
  click_name,
  click_source
) => {
  try {
    const response = await fetch(`${config.API_URL}/${apiPath}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-event-type": `${apiPath}`,
        Authorization: `Bearer ${localStorage.getItem(
          config.LOCAL_KEYS.SIGNUP_TOKEN
        )}`,
      },
      body: JSON.stringify(data),
    });

    // Track API call
    clickedApis.push(apiPath);
    localStorage.setItem("APIS_CALLED", clickedApis);

    if (!response.ok) {
      const errorData = await response.json();
      const errorMessage = errorData.message || "Something went wrong";

      // Track button click with error details
      trackBtnClick(click_name, click_source, errorMessage);

      // Log the error to Sentry if it's not for "approval/check"
      if (apiPath !== "approval/check") {
        const error = new Error(errorMessage);
        error.response = response;
        error.apiPath = apiPath;
        error.data = errorData;

        handleAndTrackError(error, {
          data,
          apiPath,
          click_name,
          click_source,
          errorData,
        });
      }
    }

    // Track button click on successful API response
    trackBtnClick(click_name, click_source);

    return await response.json();
  } catch (error) {
    console.error("API error:", error);

    // Log the error to Sentry if not already captured
    if (!error.loggedToSentry) {
      handleAndTrackError(error, {
        data,
        apiPath,
        click_name,
        click_source,
      });
    }
  }
};

export const updateFunctionB2B = async (
  data,
  apiPath,
  click_name,
  click_source,
  authToken
) => {
  try {
    console.log("data: ", data);

    const response = await fetch(`${config.API_URL}/${apiPath}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-event-type": `${apiPath}`,
        Authorization: `Short ${authToken}`,
      },
      body: JSON.stringify(data),
    });

    // Track API call
    clickedApis.push(apiPath);
    localStorage.setItem("APIS_CALLED", clickedApis);

    if (!response.ok) {
      const errorData = await response.json();
      const errorMessage = errorData.message || "Something went wrong";

      // Track button click with error details
      trackBtnClick(click_name, click_source, errorMessage);

      // Log the error to Sentry if it's not for "approval/check"
      if (apiPath !== "approval/check") {
        const error = new Error(errorMessage);
        error.response = response;
        error.apiPath = apiPath;
        error.data = errorData;

        handleAndTrackError(error, {
          data,
          apiPath,
          click_name,
          click_source,
          errorData,
        });
      }
    }

    // Track button click on successful API response
    trackBtnClick(click_name, click_source);

    return await response.json();
  } catch (error) {
    console.error("API error:", error);

    // Log the error to Sentry if not already captured
    if (!error.loggedToSentry) {
      handleAndTrackError(error, {
        data,
        apiPath,
        click_name,
        click_source,
      });
    }
  }
};

export const deleteFunction = async (apiPath) => {
  try {
    const response = await fetch(`${config.API_URL}/${apiPath}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-event-type": `${apiPath}`,
        Authorization: `Bearer ${localStorage.getItem(
          config.LOCAL_KEYS.SIGNUP_TOKEN
        )}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const errorMessage = errorData.message || "Something went wrong";

      const error = new Error(errorMessage);
      error.response = response;
      error.apiPath = apiPath;
      error.errorData = errorData;

      handleAndTrackError(error, {
        apiPath,
        responseStatus: response.status,
        errorData,
      });
    }

    return await response.json();
  } catch (error) {
    handleAndTrackError(error, { apiPath });
  }
};

export const fetchData = async (apiPath) => {
  try {
    const response = await fetch(`${config.API_URL}/${apiPath}`, {
      method: "GET",
      headers: {
        "x-event-type": `${apiPath}`,
        Authorization: `Bearer ${localStorage.getItem(
          config.LOCAL_KEYS.SIGNUP_TOKEN
        )}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const errorMessage = errorData.message || "Failed to fetch data.";
      const error = new Error(errorMessage);
      error.response = response;
      error.apiPath = apiPath;
      error.errorData = errorData;

      // Log error to Sentry with context
      handleAndTrackError(error, {
        apiPath,
        responseStatus: response.status,
        errorData,
      });
    }

    const data = await response.json();
    return data;
  } catch (error) {
    handleAndTrackError(error, { apiPath });
  }
};
export  const handleSendSlack = async (data) => {
    

    try {
      const response = await fetch(`${config.API_URL}/b2b/public/post-to-slack`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log("Success:", result);
    } catch (error) {
      console.error("Error posting to webhook:", error);
    }
  };

export const getDataB2B = async (apiPath, authToken) => {
  // Refuse to send a request we already know is doomed. `authToken` has repeatedly reached
  // here as real JS `null`/`undefined` (a caller read a localStorage key that hadn't been
  // written yet) and got template-literal-stringified into the literal text "Short null" /
  // "Short undefined" — the server then has to reject it as "no such link", which reads to
  // the tenant as a generic OTP failure. Failing fast client-side, with a distinct tracked
  // reason, converts a doomed network round trip into an immediate, diagnosable no-op —
  // every caller that already passes a real token is completely unaffected.
  if (!authToken || authToken === "null" || authToken === "undefined") {
    const error = new Error(
      "getDataB2B called with a missing/invalid authToken; request not sent"
    );
    handleAndTrackError(error, { apiPath, event: "client_missing_identifier" });
    return {
      success: false,
      errorCode: "CLIENT_MISSING_IDENTIFIER",
      message: "Something went wrong loading this page. Please refresh and try again.",
    };
  }

  try {
    const response = await fetch(`${config.API_URL}/${apiPath}`, {
      method: "GET",
      headers: {
        "x-event-type": `${apiPath}`,
        Authorization: `Short ${authToken}`,
      },
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const error = new Error(data.message);

      handleAndTrackError(error, {
        apiPath,
        responseStatus: data.errorCode,
        errorData: data.message,
      });
      return data;
    }
    return data;
  } catch (error) {
    handleAndTrackError(error, { apiPath });
  }
};

/**
 * Turns whatever getDataB2B (or a similarly-shaped "did we even reach our backend" call)
 * returned into a message that's honest about which side a failure is on — a tenant should
 * never be told a generic "something failed" for a problem that's plausibly on THEIR
 * connection when we can tell the difference server-side-reached vs never-left-the-phone.
 * Shared by every B2B OTP-request screen so the wording never drifts between them.
 */
export const getUserFacingErrorMessage = (response) => {
  // getDataB2B's own catch block returns nothing on a genuine fetch()-level failure (offline,
  // DNS, timeout) — the request never reached us at all.
  if (response === undefined) {
    return "We couldn't reach our servers. Please check your internet connection and try again.";
  }

  const numericErrorCode = Number(response?.errorCode);
  // A real HTTP response proves connectivity was fine; a 5xx, or a non-JSON error body that
  // parsed down to {} (typical of an infra-level 502/503 in front of the API, not the app
  // itself), both mean OUR side broke, not the tenant's.
  const looksLikeOurFault =
    (Number.isFinite(numericErrorCode) && numericErrorCode >= 500) ||
    (!response?.errorCode && !response?.message);

  if (looksLikeOurFault) {
    return "Something went wrong on our end. Please try again in a moment — if it keeps happening, contact support.";
  }

  return response?.message || "Failed to send OTP. Please try again.";
};

export const bankingStart = async (apiPath, data) => {
  try {
    // Define the API endpoint
    const apiUrl = `${config.API_URL}/${apiPath}`;

    // Make the POST request
    const response = await fetch(apiUrl, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        event: `${apiPath}`,
        "Content-Type": "application/json",
        "x-event-type": `${apiPath}`,
        Authorization: `Bearer ${localStorage.getItem(
          config.LOCAL_KEYS.SIGNUP_TOKEN
        )}`,
      },
    });

    // Check if the response is okay
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const errorMessage =
        errorData.message || "Failed to start banking operation.";
      const error = new Error(errorMessage);

      // Attach additional context to the error
      error.response = response;
      error.errorData = errorData;

      // Centralized error handling
      handleAndTrackError(error, {
        apiPath,
        requestBody: data,
        responseStatus: response.status,
        responseError: errorData,
      });
    }

    // Parse the response JSON
    const result = await response.json();
    return result;
  } catch (error) {
    // Handle unexpected errors centrally
    handleAndTrackError(error, {
      apiPath,
      requestBody: data,
    });
  }
};

export const deleteUser = async (apiPath, userId) => {
  try {
    // Define the API endpoint
    const apiUrl = `${config.API_URL}/${apiPath}/${userId}`;

    // Make the DELETE request
    const response = await fetch(apiUrl, {
      method: "DELETE",
      headers: {
        "x-event-type": `${apiPath}`,
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem(
          config.LOCAL_KEYS.SIGNUP_TOKEN
        )}`,
      },
    });

    if (response.ok) {
      // Parse and return the result on success
      const result = await response.json();
      console.log("User deleted successfully:", result);
      return result;
    } else {
      // Handle non-OK responses
      const errorData = await response.json().catch(() => ({}));
      const errorMessage = errorData.message || "Failed to delete user.";
      const error = new Error(errorMessage);
      error.response = response;
      error.errorData = errorData;

      // Log the error and throw it
      handleAndTrackError(error, {
        apiEndpoint: apiUrl,
        userId,
        responseStatus: response.status,
        responseError: errorData,
      });
    }
  } catch (error) {
    // Handle unexpected errors
    handleAndTrackError(error, {
      apiEndpoint: apiPath,
      userId,
    });
  }
};

export const validateTenantData = (tenantData, setError) => {
  for (let index = 0; index < tenantData.length; index++) {
    const { name, phone } = tenantData[index];

    if (name.trim() === "") {
      setError(`Error at Tenant ${index + 2}: Name cannot be empty.`);
      return false;
    }
    if (!/^\d{10}$/.test(phone)) {
      setError(`Error at Tenant ${index + 2}: Phone number must be 10 digits.`);
      return false;
    }
  }

  return true;
};

export const whatsappLandlordURL = (phoneNumber, referralCode) => {
  if (isValidPhone(phoneNumber)) {
    const message = `Dear Landlord,

Congratulations!

As your new tenant, I'm inviting you to join CirclePe Club - an IIT-IIM venture, giving exclusive benefits to landlords.

You can see benefits at ${`https://join.circlepe.in/l?r=${referralCode}`}

CirclePe team shall reach out to you shortly.
Thank You!`;

    const encodedMessage = encodeURIComponent(message);
    const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    return url;
  } else return;
};

export const inviteFriends = () => {
  const message = `Heyy, wanted to make your security deposit to zero, join CirclePe Club here - ${`https://join.circlepe.in/`}`;

  const encodedMessage = encodeURIComponent(message);
  const url = `https://wa.me/?text=${encodedMessage}`;
  window.open(url, "_blank");
};

export const dropWaMessage = async (click_name, click_source) => {
  try {
    trackBtnClick(click_name, click_source);
    await updateFunction({}, "landlord/share-invite");
  } catch (error) {
    console.error("Error sending WhatsApp message:", error);
    return null;
  }
};

// export const chatWaMessage = async () => {
//   const message = "Hi, I am a tenant and onboarded at CirclePe. I have some query!";
//   const encodedMessage = encodeURIComponent(message);
//   const url = `https://wa.me/8920254690?text=${encodedMessage}`;
//   window.open(url, "_blank");
// };

export const chatHelpMessage = async () => {
  window.open(supportURL, "_blank");
};
export const callHelpMessage = async () => {
  window.open("tel:7007672505", "_blank");
};

export const trackBtnClick = (click_name, click_source, message) => {
  try {
    posthog.capture(`${click_name} - ${click_source}`, {
      "Click Name": click_name,
      "Click Source": click_source,
      Message: message || null,
    });
  } catch (error) {
    // Log the tracking error to Sentry
    handleAndTrackError(error);
  }
};

export const trackPageView = (page_name, page_source, message) => {
  try {
    posthog.capture(`${page_name} - ${page_source}`, {
      "Page Name": page_name,
      "Page Source": page_source,
      Message: message || null,
    });
  } catch (error) {
    // Log the tracking error to Sentry
    handleAndTrackError(error);
  }
};

export const trackError = (error_name, error_source, message) => {
  // Sentry.captureException(new Error(message), {
  //   extra: {
  //     error_name,
  //     error_source,
  //     message,
  //   },
  // });
  posthog.capture(`${error_name} - ${error_source}`, {
    "Error Name": error_name,
    "Error Source": error_source,
    Message: message || null,
  });
};

export const handleAndTrackError = (error, context = {}) => {
  posthog.capture(error, context);
  //  Sentry.captureException(error);
  console.error("Error:", error);
};

export function formatDate(dateString, format = "DD-MM-YYYY") {
  const date = new Date(dateString);

  const pad = (num) => num.toString().padStart(2, "0");

  const day = pad(date.getUTCDate());
  const month = pad(date.getUTCMonth() + 1); // Months are 0-indexed
  const year = date.getUTCFullYear();

  if (format === "DD-MM-YYYY") {
    return `${day}-${month}-${year}`;
  } else if (format === "YYYY-MM-DD") {
    return `${year}-${month}-${day}`;
  } else if (format === "MM/DD/YYYY") {
    return `${month}/${day}/${year}`;
  }

  return date.toISOString(); // Default fallback
}

export function mergeAddress(line1, line2) {
  if (!line1) return line2 || ""; // If line1 is null, return line2
  if (!line2) return line1; // If line2 is null, return line1

  const words1 = line1.split(" ");
  const words2 = line2.split(" ");

  // Find the overlapping index
  let overlapIndex = null;
  for (let i = 0; i < words1.length; i++) {
    if (
      words2.slice(0, words1.length - i).join(" ") === words1.slice(i).join(" ")
    ) {
      overlapIndex = i;
      break;
    }
  }

  // Merge the lines without duplication
  if (overlapIndex !== null) {
    return [...words1.slice(0, overlapIndex), ...words2].join(" ");
  } else {
    return `${line1} ${line2}`; // If no overlap found, concatenate both
  }
}
// utils/session.js

export function getSessionId() {
  const STORAGE_KEY = "sessionId";
  const DAY_IN_MS = 24 * 60 * 60 * 1000;

  let sessionData = null;
  try {
    sessionData = JSON.parse(localStorage.getItem(STORAGE_KEY));
  } catch (err) {
    // no-op if parse fails
  }

  const now = Date.now();

  if (!sessionData || now > sessionData.expiresAt) {
    // Generate valid 128-bit (32 hex char) trace ID
    const idBytes = window.crypto.getRandomValues(new Uint8Array(16));
    const id = Array.from(idBytes)
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");

    sessionData = {
      id,
      expiresAt: now + DAY_IN_MS,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(sessionData));
  }

  return sessionData.id;
}
